// import React, { Component } from "react";
import { DeviceContext } from "context/deviceProvider";
import { MaintenanceContext } from "context/maintenanceProvider";
import { Button, Form, Icon, Input, Modal, Select } from "semantic-ui-react";
import "scss/components/modals/deviceStatusDetail.scss";
import SemanticDatepicker from "react-semantic-ui-datepickers";
import Swal from "sweetalert2";

import React, { useState, useContext } from "react";

export default function DeviceStatusDetail(props) {
  const [partCode, setPartCode] = useState("");
  const [note, setNote] = useState("");
  const [states, setStates] = useState("");
  const [appointmentDate, setAppointmentDate] = useState(null);
  const devices = useContext(DeviceContext);
  const maintenances = useContext(MaintenanceContext);

  const setAlert = async (title, content, icon) => {
    Swal.fire({
      title: title,
      text: content,
      icon: icon,
      confirmButtonText: "OK",
    });
  };

  const deviceDataTable = () => {
    const deviceParts = devices?.partsList?.map((parts) => ({
      key: parts.code,
      value: parts.code,
      text: parts.name_th,
    }));
    const processState = [
      { key: "draft", value: "draft", text: "แจ้งลูกค้าเรียบร้อย" },
      {
        key: "contact_fail",
        value: "contact_fail",
        text: "ติดต่อลูกค้าไม่ได้",
      },
      { key: "later", value: "later", text: "ติดต่ออีกครั้งวันที่" },
    ];
    return (
      <table>
        <tbody>
          <tr>
            <td>ชื่อผู้ใช้งาน</td>
            <td>
              <Form.Field>
                <Input value={props.deviceDetail?.user_id} readOnly />
              </Form.Field>
            </td>
          </tr>
          <tr>
            <td>หมายเลขเครื่องจักร</td>
            <td>
              <Form.Field>
                <Input value={props.deviceDetail?.name} readOnly />
              </Form.Field>
            </td>
          </tr>
          <tr>
            <td>สถานะอะไหล่</td>
            <td>{createPartsStatus()}</td>
          </tr>
          <tr>
            <td>
              แจ้งซ่อมอะไหล่<span style={{ color: "red" }}>*</span>
            </td>
            <td>
              <Form.Field
                control={Select}
                options={deviceParts}
                placeholder="แจ้งซ่อมอะไหล่"
                search
                value={partCode}
                onChange={(e, { value }) => setPartCode(value)}
              />
            </td>
          </tr>
          <tr>
            <td>หมายเหตุ</td>
            <td>
              <Form>
                <Form.TextArea
                  placeholder="หมายเหตุ"
                  onChange={(e) => setNote(e.target.value)}
                />
              </Form>
            </td>
          </tr>
          <tr>
            <td>
              สถานะดำเนินการ<span style={{ color: "red" }}>*</span>
            </td>
            <td>
              <Form.Field
                control={Select}
                options={processState}
                placeholder="สถานะดำเนินการ"
                value={states}
                onChange={(e, { value }) => setStates(value)}
              />
            </td>
          </tr>
          {states === "later" && (
            <tr>
              <td></td>
              <td>
                <SemanticDatepicker
                  onChange={(e, { value }) => setAppointmentDate(value)}
                />
              </td>
            </tr>
          )}
        </tbody>
      </table>
    );
  };

  const createPartsStatus = () => {
    return (
      <div className="parts">
        {devices?.partsStatusList?.parts?.map((parts, idx) => (
          <div className="parts-status" key={`${parts.ma_code}=${idx}`}>
            <Icon status={parts.caution_level} name="circle" />
            &ensp;{parts.name_th}
          </div>
        ))}
      </div>
    );
  };

  const createButton = () => {
    return (
      <>
        <Button basic color="red" onClick={() => props.isClose()}>
          ยกเลิก
        </Button>
        <div className="button">
          <Button color="blue" onClick={() => onAddMaintenance("save")}>
            บันทึก
          </Button>
          &emsp;
          <Button color="red" onClick={() => onAddMaintenance("add")}>
            แจ้งซ่อม
          </Button>
        </div>
      </>
    );
  };

  const onAddMaintenance = async (button) => {
    let status = "";
    let date = null;
    let formData = new FormData();

    if (partCode === "" || states === "") {
      setAlert("Error!", "กรุณากรอกข้อมูลให้ครบถ้วน", "error");
    } else {
      if (button === "save") {
        status = states;
        // if (states === "contacted") {
        //   status = "draft";
        // }
        date = new Date().toLocaleDateString();
      } else {
        status = "contacted";
        // status = states;
      }

      const dataAddMaintenance = {
        maCode: null,
        userId: props.deviceDetail?.user_id,
        note: note,
        workerId: "manager",
        clpSerial: props.deviceDetail?.name,
        partCode: partCode,
        // phoneNo: ,
        engineerName: null,
        topic: null,
        contactChoice: null,
        handleNote: null,
        inWarranty: 1,
        appointmentDate:
          appointmentDate?.toLocaleString().substring(0, 9) || date,
        confirmSerial: null,
        state: status,
      };
      formData.append("data", JSON.stringify(dataAddMaintenance));
      let result = await maintenances.addMaintenance(formData);
      if (result?.code === 0) {
        await setAlert("Success!", "เพิ่ม/บันทึก การแจ้งซ่อมสำเร็จ", "success");
        props.isClose();
      } else {
        await setAlert("Error!", "เพิ่ม/บันทึก การแจ้งซ่อมไม่สำเร็จ", "error");
      }
    }
  };

  return (
    <div className="deviceStatusDetail">
      <Modal
        // dimmer="blurring"
        open={props.isOpen}
        onClose={() => props.isClose()}
      >
        <Modal.Header>
          <h2>ติดตามสถานะอะไหล่</h2>
        </Modal.Header>
        <Modal.Content>{deviceDataTable()}</Modal.Content>
        <Modal.Actions>{createButton()}</Modal.Actions>
      </Modal>
    </div>
  );
}
